import { Close, FileUploadOutlined } from "@mui/icons-material";
import { Autocomplete, ButtonBase, TextField, Chip } from "@mui/material";
import React, { Fragment, useRef, useEffect } from "react";

const FileUploadField = ({
    textfieldProps,
    autoCompleteProps,
    multiple,
    files,
    setFiles,
}) => {
    const fileRef = useRef(null);

    useEffect(() => {
        if (files.length === 0 && fileRef.current) {
            fileRef.current.value = "";
        }
    }, [files]);

    const handleFileSelection = (e) => {
        const selectedFiles = e.target.files;
        if (multiple) {
            setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
        } else {
            setFiles(selectedFiles);
        }
    };
    const openFileDialog = (e) => {

        e.preventDefault();
        e.stopPropagation();

        fileRef.current.click();
    };
    return (
        <Fragment>
            <Autocomplete
                multiple
                options={Array.from(files)}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        {...(textfieldProps ?? {})}
                        disabled
                        onClick={openFileDialog}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <Fragment>
                                    {files.length > 0 && (
                                        <ButtonBase
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setFiles([]);
                                            }}
                                            sx={{
                                                paddingRight: "0.5rem",
                                            }}
                                        >
                                            {/* <Close  sx={{fontSize:"34px"}}/> */}
                                        </ButtonBase>
                                    )}
                                    <ButtonBase>
                                        <FileUploadOutlined onClick={openFileDialog} sx={{ fontSize: "34px" }} />
                                    </ButtonBase>
                                </Fragment>
                            ),
                        }}

                        sx={{
                            color: "inherit",
                            "& .MuiInputBase-root , & .MuiInputBase-input": {
                                paddingRight: "1rem !important",
                                cursor: "pointer",
                            },
                            // width: "30%"
                        }}
                    />
                )}
                value={Array.from(files)}
                onChange={(event, newValue) => {
                    event.preventDefault();
                    setFiles(newValue);
                }}
                open={false}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (

                            <Chip
                                key={key}
                                label={option.name}
                                {...tagProps}

                                sx={{
                                    backgroundColor: '#5a20d7e6', // Customize the background color
                                    color: 'white', // Customize the text color
                                    marginRight: '0.5rem',
                                    // height:"40px",
                                    // fontSize: "larger",
                                    '& .MuiChip-deleteIcon': {
                                        color: 'white', // Customize the delete icon color
                                    },

                                }}
                            />
                        )
                    })
                }
                sx={{
                    caretColor: "transparent",
                    cursor: "pointer",
                    "& .Mui-disabled,& .MuiInputLabel-root": {
                        color: "rgba(0,0,0,0.6)",
                        backgroundColor: "transparent",
                    },
                    height: "64px"

                }}
                {...(autoCompleteProps ?? {})}
            />
            <input
                type="file"
                ref={fileRef}
                accept=".xls,.xlsx"
                style={{ display: "none" }}
                onChange={handleFileSelection}
                multiple={multiple}
            />
        </Fragment>
    );
};

export default FileUploadField;